import React, {Component} from 'react';
import {Button, Image, ListGroup, ListGroupItem, Nav, Navbar, NavItem, Row} from 'react-bootstrap';
import {connect} from 'react-redux';
import {fetch_categories, set_search_value} from './actions';
import {Link, Redirect, withRouter} from 'react-router-dom';
import {open_login_modal} from '../../actions';
import {fetch_user_details, logout} from '../loginModal/actions';
import {DataSearch, ReactiveBase} from '@appbaseio/reactivesearch';
import {toastr} from 'react-redux-toastr';
import Sidebar from "react-sidebar";
import {useMediaQuery} from 'react-responsive'

import './style.css';

class NavBar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            _show_navbar: true,
            enable_navbar_search: false,
            redirect: false,
            redirect_url: null,
            sidebar_open:false,
            show_cats: false
        }
    }

    redirect_page = (url) => {
        this.setState({redirect_url: url, redirect: true})
    }

    logout = () => {
        this.props.logout()
        .then(() => {
            this.props.fetch_user_details()
            toastr.success('You have been Logged Out')
        })
    }


    componentDidMount(){
        window.addEventListener('scroll', this.handle_scroll);
        function checkURL(this_as_param) {
            var _pathname = window.location.pathname.split('/');
            const invalid_pathname = 'designmaker';
            // const invalid_pathnames = ['designs', 'dashboard', 'brand-kit', 'shared-designs', 'wizard', 'admin_designs', 'admin_text_templates', 'folders', 'generate-designs', 'all-designs', 'share', 'orders'];
            if (_pathname.length >= 2 && (invalid_pathname == _pathname[1])) {
                this_as_param.setState({_show_navbar: false})
            }else{
                this_as_param.setState({_show_navbar: true})
            }
            if (_pathname.length <= 3 && _pathname[1] == 'mockups' && !_pathname[2]) {
                this_as_param.setState({show_cats: true})
            } else {
                this_as_param.setState({show_cats: false})
            }
        }

        this.props.history.listen((location, action) => {
            checkURL(this)
        });

        checkURL(this)
    }

    inmagine_login = () => {
        window.localStorage.setItem('last_url', window.location.href);
        window.location.href = global.config.designs_ai_server_path + "user/sign-in?c="+global.config.mm_client_id+"&r=" + global.config.auth_redirect_path_mm;
    }

    inmagine_logout = () => {
        window.localStorage.setItem('last_url', window.location.href);
        fetch(global.config.server_path+'user/logout', {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include'})
            .then(res => {
                window.location.href = global.config.designs_ai_server_path + "user/sign-out?c="+global.config.mm_client_id+"&r=" + global.config.auth_redirect_path_mm;
            })
            .catch(err => {
                console.error(err);
                window.location.href = global.config.designs_ai_server_path + "user/sign-out?c="+global.config.mm_client_id+"&r=" + global.config.auth_redirect_path_mm;
            })
    }

    handle_scroll = () => {
        if (window.scrollY > 212) {
            this.setState({enable_navbar_search: true})
        } else {
            this.setState({enable_navbar_search: false})
        }
    }

    open_sidebar = open => {
        this.setState({ sidebar_open: open });
    }


    render() { 
        var {redirect, redirect_url} = this.state;
        if (redirect) {
            return (<Redirect push to={redirect_url} />)
        }



        const Desktop = ({ children }) => {
            const isDesktop = useMediaQuery({minWidth: 992})
            return isDesktop ? children : null
        }
        
        const Tablet = ({ children }) => {
            const isTablet = useMediaQuery({maxWidth: 991})
            return isTablet ? children : null
        }

        const styles = {
            brand: {
                paddingLeft: 31,
                color: '#2572CE', 
                fontSize: 26, 
                fontWeight: '800', 
                fontFamily: "Montserrat", 
            },
            navbar: {
                boxShadow: "0 2px 16px 0 rgba(177,177,177,0.5)",
                color: "white", 
                fontFamily: 'Montserrat',
                position: 'fixed',
                width: '100%',
                zIndex: 120 
            },
            brand_subscript: {
                color:"#333333", 
                fontSize: 14, 
                float: 'right'
            },
            profile_button: {
                backgroundColor: 'white',
                color: '#333333',
                fontSize: 14
            },
            navbar_item: {
                marginTop: 6
            }
        }
        
        var login_button = (<Desktop><Button onClick={this.inmagine_login} className="btn btn-blue btn-login" id="login_button">Sign in</Button></Desktop>)
        var login_button_all = (<Button onClick={this.inmagine_login} className="btn btn-blue btn-login" id="login_button">Sign in</Button>)

        const category_list = (
            <ListGroup>
                <ListGroupItem>
                    {this.props.user && this.props.user.email ? (
                        <div className="dropdown">
                          <div className="btn" style={styles.profile_button} type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                            <Image src="https://image.flaticon.com/icons/svg/206/206853.svg" className="circle" style={{position: 'absolute', left: '-40px', bottom:0, height: 40}}/>
                            {this.props.user.name} &nbsp;
                            <span className="fa fa-caret-down"></span>
                          </div>
                          <ul className="dropdown-menu" aria-labelledby="dropdownMenu1">
                            <li><a onClick={() => this.redirect_page('/orders')}>Your Orders</a></li>
                            <li role="separator" className="divider"></li>
                            <li><a onClick={this.inmagine_logout}>Logout</a></li>
                          </ul>
                        </div>
                    ) : login_button_all}
                </ListGroupItem>
                
                {this.state.show_cats && this.props.categories && this.props.categories.filter(x => (x.mockup_length > 0)).map((cat, idx) => 
                    <ListGroupItem>
                            <Button key={"category_"+idx+"_btn"} className=" category_list_button" style={{cursor: "pointer", width: '100%'}} onClick={() => window.apply_category_filter(cat)} >{cat.name}<span style={{float: 'right'}}>{cat.mockup_length}</span></Button>
                    </ListGroupItem>
                )}

            </ListGroup>
        )

        const sidebar = (
            <Sidebar
                children={[]}
                sidebar={category_list}
                open={this.state.sidebar_open}
                onSetOpen={this.open_sidebar}
                styles={{ sidebar: { background: "white" , zIndex: 200, position: 'fixed', height: 'webkit-fill-available'} }}
            />
        )

        var _navbar = (
            <div>
                <Navbar collapseOnSelect className="sticky-top" style={styles.navbar}>
                    <Navbar.Brand>
                        <Link to="/mockupmaker/start">
                            <span style={styles.brand}>
                                Mockupmaker<br/> 
                                <span style={styles.brand_subscript}><span className="superscript">by </span>Designs.ai</span>
                            </span>
                        </Link>
                    </Navbar.Brand>
                    <Desktop>
                        <Nav style={{width: 530, marginTop: 6, marginLeft: 'calc(50% - 500px)'}}>
                            <NavItem style={{width: 530, display: this.state.enable_navbar_search ? 'block' : 'none'}}>

                                <ReactiveBase app="mockups" style={{position: 'relative'}} url={global.config.server_path}>
                                    <DataSearch
                                        componentId="mainSearch"
                                        dataField={["name", "categories.name", "keywords", "description"]}
                                        queryFormat="or"
                                        className="mockup_search"
                                        innerClass={{
                                            "input": "mockup_search_box",
                                            "list": "suggestionlist"
                                        }}
                                        placeholder={"All mockups"}
                                        showIcon={false}
                                        onValueSelected={(value) => {
                                            this.props.set_search_value(value);
                                        }}
                                        renderSuggestion={(suggestion) => {return {
                                            label: suggestion.source.categories ? (<div><Row>{suggestion.source.name}</Row><Row> <span style={{color : '#2572CE', textAlign : 'right'}}> in {suggestion.source.categories[0].name}</span></Row></div>) : (<div style={{color : '#2572CE', textAlign : 'right'}}>{suggestion.source.name}</div>),
                                            value : suggestion.source.name,
                                            source : suggestion.source
                                        }}}
                                    />
                                    <span style={{position: 'absolute', right: 7, fontSize: 28, top: 7, zIndex: 170, color: '#F1F1F1', textSjadow: 'none'}} className="fas fa-search fa-2x" />
                                </ReactiveBase>
                            </NavItem>
                        </Nav>
                    </Desktop>
                    <Desktop>
                        <Nav pullRight>
                            <NavItem style={styles.navbar_item}>
                                {this.props.user && this.props.user.email ? (
                                    <div className="dropdown">
                                      <div className="btn" style={styles.profile_button} type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                        <Image src="https://image.flaticon.com/icons/svg/206/206853.svg" className="circle" style={{position: 'absolute', left: '-40px', bottom:0, height: 40}}/>
                                        {this.props.user.name} &nbsp;
                                        <span className="fa fa-caret-down"></span>
                                      </div>
                                      <ul className="dropdown-menu" aria-labelledby="dropdownMenu1">
                                        <li><a href="/orders" onClick={() => this.redirect_page('/orders')}>Your Orders</a></li>
                                        <li role="separator" className="divider"></li>
                                        <li><a onClick={this.inmagine_logout}>Logout</a></li>
                                      </ul>
                                    </div>
                                ) : login_button}
                            </NavItem>
                        </Nav>
                    </Desktop>
                    <Tablet>
                        <div style={{float: 'right'}}><span style={{borderTop: 6}} className="fa fa-menu fa-2x"/></div>
                    </Tablet>
                    <Navbar.Toggle onClick={() => this.open_sidebar(true)} />
                    <Navbar.Collapse>
                    </Navbar.Collapse>
                </Navbar>
            </div>
        );

        if (this.state._show_navbar) {
            return (
                <div>
                    {sidebar}
                    {_navbar}
                </div>);
        }
        else {
            return '';
        }
    }
}

const mapStateToProps = function(state) {
    return {
        categories: state.categories,
        user: state.user,
    }
}

const mapDispatchToProps = dispatch => ({
    show_mockups: () => {
        dispatch(fetch_categories())
    },
    open_login_modal: () => {
        dispatch(open_login_modal());
    },
    logout: () => {
        return dispatch(logout());
    },
    fetch_user_details: () => {
        return dispatch(fetch_user_details());
    },
    set_search_value: x => {
        return dispatch(set_search_value(x));
    }
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NavBar));
